<template>
  <div>wait</div>
</template>

<script>
export default {

}
</script>

<style>

</style>